import { render, staticRenderFns } from "./apPurchaseStat.vue?vue&type=template&id=5bde3340&"
import script from "./apPurchaseStat.vue?vue&type=script&lang=js&"
export * from "./apPurchaseStat.vue?vue&type=script&lang=js&"
import style0 from "./apPurchaseStat.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "apPurchaseStat.vue"
export default component.exports